import React from 'react';
import MeridianPaginationComponent from '@amzn/meridian/pagination';
import Text from '@amzn/meridian/text';

type Pagination = Omit<
  React.ComponentProps<typeof MeridianPaginationComponent>,
  'aria-label'
>;

interface SessionPagination {
  title: string;
  pagination: Pagination;
}

const SESSION_HISTORY_PAGES_LABEL = 'Session history pages';

const SessionPaginationComponent: React.FC<SessionPagination> = ({
  title,
  pagination,
}) => (
  <div className="sessions-pagination">
    <Text type="b200">{title}</Text>
    <MeridianPaginationComponent
      {...pagination}
      aria-label={SESSION_HISTORY_PAGES_LABEL}
    />
  </div>
);

export default SessionPaginationComponent;
